<template>
  <div
    class="TableOverflowSolverWrapper relative"
    :class="{
      'isOverflowed': isOverflowed,
      'isOnEnd': isOnEnd,
      'isOnStart': isOnStart
    }"
  >
    <div
      class="TableOverflowSolver mb-8 shadow-md rounded-md"
      ref="solver"
      style="max-width: 100%; overflow-x: auto"
      @scroll="scrollBehavior"
    >
      <slot></slot>
    </div>

    <div class="TableOverflowSolverOverLayStart"></div>
    <div class="TableOverflowSolverOverLayEnd"></div>
  </div>
</template>

<script>
const isOverflowed = (element) => {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  )
}

export default {
  data() {
    return {
      isOverflowed: false,
      isOnStart: true,
      isOnEnd: false
    }
  },
  computed: {},

  methods: {
    scrollBehavior() {
      const el = this.$refs.solver
      let isOnStart = false
      let isOnEnd = false

      if (Math.ceil(el.scrollLeft) >= el.scrollWidth - el.clientWidth) {
        isOnEnd = true
      }

      if (el.scrollLeft < 1) {
        isOnStart = true
      }

      this.isOnStart = isOnStart
      this.isOnEnd = isOnEnd
    },
    overflowDetect() {
      this.isOverflowed = isOverflowed(this.$refs.solver)
    }
  },
  mounted() {
    window.addEventListener('resize', this.overflowDetect)
    this.overflowDetect()
  },
  unmounted() {
    window.removeEventListener('resize', this.overflowDetect)
  }
}
</script>

<style lang="scss" scoped>
.TableOverflowSolverOverLayStart,
.TableOverflowSolverOverLayEnd {
  content: '';
  top: 0;
  bottom: 0;
  width: 50px;
  @apply absolute z-10;
  @apply invisible opacity-0;
  @apply transition-all duration-150 ease-in-out;
}

.TableOverflowSolverOverLayStart {
  left: 0;
  @apply bg-gradient-to-r from-bc-gray-bg to-transparent;
}

.TableOverflowSolverOverLayEnd {
  right: 0;
  @apply bg-gradient-to-l from-bc-gray-bg to-transparent;
}

.isOverflowed {
  .TableOverflowSolverOverLayStart, 
  .TableOverflowSolverOverLayEnd {
    @apply visible opacity-100;
  }
}

.isOverflowed.isOnStart {
  .TableOverflowSolverOverLayStart {
    @apply invisible opacity-0;
  }
}

.isOverflowed.isOnEnd {
  .TableOverflowSolverOverLayEnd {
    @apply invisible opacity-0;
  }
}
</style>
